module.exports = __webpack_public_path__ + "img/政策与制度_02.4c5602a7.jpg";